import React from "react";
import "./Cart.css";
import {
    createElements, getCurrency, getDatas,
    getUtms,
    hidePage,
    makeLogo,
    setTable,
    showAnyMore,
    showPage,
    updateCartNumber
} from "../extras/Actions";
import AnyMore from "../AnyMore/AnyMore";
import FondoCopos from "../Copitos/Copitos";
export default class Cart extends  React.Component{

    componentDidMount() {
        getCurrency()
        setTable()
        getUtms();
        hidePage()
        if (window.location.href.includes("cart") && localStorage.getItem("donors") !== null){
            makeLogo()
        }else{
            getDatas()
        }

        createElements()
        updateCartNumber()
        setTimeout(showPage,3000)
    }

    render() {
        return (
            <div className="cart_container">
                <div className="subtotal">

                </div>
                <div className="cart-items">
                    <div className="nothing">
                        SIN REGALOS
                    </div>
                </div>
                <button className="checkout link pago" onClick={showAnyMore}>
                    Continuar
                </button>

                <a href="/gifts" className="checkout link gifts d-none">
                    Agregar productos
                </a>
                <AnyMore/>
                <FondoCopos copitos={150}/>
            </div>
        );
    }
}